import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class EventTimingpointRoute extends Route {
  @service eventData;

  model(params) {
    // timingpoint_uuid is a UUID string
    const timingPointUuid = params.timingpoint_uuid;
    // Get eventUuid from parent route
    const eventUuid = this.paramsFor('event').event_uuid;

    console.log(`[EventTimingpointRoute] Loading timingpoint ${timingPointUuid} for event ${eventUuid}`);

    return {
      eventUuid,
      timingPointUuid
    };
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    // Reset controller state for fresh baseline tracking
    controller.resetState();
  }

  deactivate() {
    super.deactivate(...arguments);
    // Stop the fade timer when leaving the route
    this.controller.stopFadeTimer();
  }
}
